import styled from 'styled-components';
import { body2 } from 'ui/theme';
import { SecondaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { pxToRem } from 'utils/convert';
import WorkflowSelect from './WorkflowSelect';

export const StyledFormField = styled(FormField)`
  label {
    align-items: center;
  }
`;

export const StyledButton = styled(SecondaryButton)`
  flex-shrink: 0;
`;

export const StyledWorkflowSelect = styled(WorkflowSelect)`
  width: 100%;
`;

export const SelectedWorkflowDetails = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.backgroundColors.backgroundSecondary};
  padding: ${pxToRem(15)};
  gap: ${pxToRem(10)};
  > div {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: ${pxToRem(10)};
    ${body2}
    > span {
      width: fit-content;
    }
  }
`;
